<input type="hidden" [formControl]="dynamicSelect" [formlyAttributes]="field" />

<div *ngIf="this.showBy != 'no'">
    <label class="filterLabelStyle" style="margin: 0 !important; z-index: 9;">{{label||"NO Lable"}}</label>

    <!-- Select Dropdown -->
    <ng-select class="ngSelection" style="font-size:13px; font-family: 'Poppins'" #sc [multiple]="true"
        [clearable]="false" [items]="option" [(ngModel)]="selectedItems" [placeholder]="this.placeholder"
        [selectableGroup]="false" [closeOnSelect]="false" [dropdownPosition]="'bottom'" (remove)="selectOption()"
        (add)="selectOption()" (open)="onOpen()" (close)="onClose()" [bindLabel]="this.labelProp" [virtualScroll]="true"
        [groupBy]="isGrouped ? groupLabelProp : 'null'">

        <!-- Search Of the Filter -->
        <ng-template ng-header-tmp>
            <input class="searchFiler" type="text" (input)="sc.filter(onFilterTextBoxChanged($event))"
                placeholder="Search" />

            <div class="form-check mr-2 multiselect-form-check">
                <input style="accent-color: #1363DF !important;" type="checkbox" [ngModel]="isChecked" (click)="selectAllClick()">
                <label class="form-check-label" for="flexCheckDefault">
                    <span *ngIf="!this.enteredText">{{ selectAllLabel }}</span>
                    <span *ngIf="this.enteredText">{{ '(' + selectAllLabel + ' Search Results)'}}</span>
                </label>
            </div>

            <div class="form-check multiselect-form-check">
                <input style="accent-color: #1363DF !important;" type="checkbox" [ngModel]="isAddChecked" (click)="selectAddClick()">
                <label class="form-check-label" for="flexCheckDefault">
                    <span>{{'Add current selection to filter'}}</span>
                </label>
            </div>
        </ng-template>

        <!-- Visible of the Filter -->
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear" let-index="index">
            <div class="ng-value" *ngFor="let item of selectedItems  | slice: 0:itemsShowLimit">
                <span class="ng-value-label">{{ item[this.labelProp]}}</span>
            </div>
            <div class="ng-value" *ngIf="selectedItems.length > itemsShowLimit">
                <span class="ng-value-label">{{ selectedItems.length - itemsShowLimit }} more...</span>
            </div>
        </ng-template>

        <!-- Group Label Template -->
        <ng-template ng-optgroup-tmp let-item="item" let-index="index">
            <div class="form-check multiselect-form-check" 
                 style="margin: 0; padding: 0px 3px; display: flex; align-items: center; cursor: pointer; background-color: #fff;"
                 (click)="onGroupDivClick(item, $event)">
                <input 
                    [id]="'group-checkbox-' + (item[groupLabelProp] || 'ungrouped')"
                    style="accent-color: #1363DF !important; pointer-events: none;" 
                    type="checkbox" 
                    [checked]="isGroupSelected(item)"
                    [attr.data-group-state]="getGroupCheckboxState(item)"
                >
                <label 
                    [for]="'group-checkbox-' + (item[groupLabelProp] || 'ungrouped')"
                    class="form-check-label" 
                    style="font-weight: 500;  font-size: 14px; color:#1363DF; cursor: pointer; margin-left: 7px; pointer-events: none;">
                    <span>{{ item[groupLabelProp] || 'Ungrouped' }}</span>
                </label>
            </div>
        </ng-template>

        <!-- Selected Check Box AND Lable name -->
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div class="form-check" style="padding-left: 3px;display: flex;align-items: center;" [class.justify-content-between]="!isRootSqBadge">
                <span class="multiselect-form-check span-decomm">
                    <input style="accent-color: #1363DF !important;" id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                        [value]="item">
                    <label [matTooltip]="item[this.toolTipKey]" [matTooltipPosition]="'above'"
                        matTooltipClass="example-tooltip-multi" style="cursor: pointer" class="form-check-label"
                        for="flexCheckDefault">
                        <span>{{item[this.labelProp] }}</span>
                    </label>
                </span>
                <span *ngIf="decomm_flag && item[decommReplaceName] == 'Y'">
                    <span [style.margin-left.px]="isRootSqBadge ? 2 : 0" [class]="isRootSqBadge ? 'du-comm-flag-badge-btn' : 'du-decomm-btn'" [matTooltip]="decommTooltip || 'Decommissioned'" 
                    [style.background]="decommColor + '33' || '#f2d3cd'"
                    [style.border-color]="decommColor || '#c04a36'"
                    [style.color]="decommColor || '#c04a36'"
                    >{{decommlabel}}</span>
                </span>
            </div>
        </ng-template>

        <!-- Apply Button -->
        <ng-template ng-footer-tmp>
            <!-- <button (click)="applyFilter(sc)" class="btn btn-sm btn-secondary buttonApply"
                [disabled]="selectedItems.length == 0">Apply</button> -->

            <div class="d-flex align-items-center py-2" style="gap: 10px">
                <button 
                    *ngIf="option.length > 0"
                    [disabled]="selectedItems.length == 0" matTooltip="Include"
                    class="btn include du-multi-select-btn" (click)="applyIncludeExcludeFilter('include', sc)">
                    <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="7" width="8" height="3" fill="#1363DF" />
                        <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
                        <path
                            d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z"
                            fill="#1363DF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z"
                            fill="#1363DF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z"
                            fill="#1363DF" />
                    </svg>
                </button>

                <button 
                    *ngIf="option.length > 0"
                    [class.disabled]="selectedItems.length === 0 ||  option.length==selectedItems.length"
                    [disabled]="selectedItems.length == 0 || option.length==selectedItems.length"
                     matTooltip="Exclude" class="btn exclude du-multi-select-btn" (click)="applyIncludeExcludeFilter('exclude', sc)">
                    <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="8" height="3" fill="#D11044" />
                        <rect y="12" width="8" height="3" fill="#D11044" />
                        <path
                            d="M11.1534 6.46002L5 6.46003L5 8.53998L11.1534 8.53998L8.76241 11.0228L10.185 12.5L15 7.5L10.185 2.5L8.76241 3.9772L11.1534 6.46002Z"
                            fill="#D11044" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M5 7H10V6.46003L5 6.46003V7ZM10 5.26234L8.78436 4H10V5.26234ZM4 7H2V4H7.76266C7.76816 4.24237 7.86131 4.48312 8.0421 4.67086L8.80207 5.46003L5 5.46003C4.44772 5.46003 4 5.90774 4 6.46003V7Z"
                            fill="#D11044" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.78436 11H9V10.7761L8.78436 11ZM9 8.53998L5 8.53998V8H9V8.53998ZM7.76267 11H1V8H4V8.53998C4 9.09226 4.44772 9.53997 5 9.53998L8.80207 9.53998L8.0421 10.3291C7.86131 10.5169 7.76816 10.7576 7.76267 11Z"
                            fill="#D11044" />
                    </svg>
        
                </button>
            
                <button 
                    *ngIf="option.length > 0"
                    [class.disabled]="option.length==selectedItems.length"
                    [disabled]="option.length==selectedItems.length"
                    (click)="applyIncludeExcludeFilter('clear', sc)"
                    matTooltip="Clear selection" class="btn exclude du-multi-select-btn">
                    <svg width="25" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M15.1233 0C15.6075 0 16 0.392499 16 0.876682C16 1.05902 15.9432 1.23684 15.8373 1.3854L12.2592 6.40765C11.9677 6.35237 11.6669 6.32344 11.3594 6.32344C8.70842 6.32344 6.55938 8.47248 6.55938 11.1234C6.55938 12.7503 7.3687 14.1881 8.60667 15.0562L7.97832 15.4751C7.19837 15.995 6.14461 15.7843 5.62468 15.0044C5.43971 14.7268 5.34054 14.401 5.33964 14.0675L5.32513 8.72486L0.159683 1.38108C-0.11886 0.985049 -0.0236423 0.438156 0.372391 0.159613C0.520046 0.055766 0.696221 0 0.876751 0H15.1233Z"
                            fill="#D11044" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.2 14.3219C12.9673 14.3219 14.4 12.8892 14.4 11.1219C14.4 9.35456 12.9673 7.92188 11.2 7.92188C9.43269 7.92188 8 9.35456 8 11.1219C8 12.8892 9.43269 14.3219 11.2 14.3219ZM11.5953 11.4889H12.8V10.7642H11.5953L11.6 10.7643H10.8L10.7953 10.7642H9.60001V11.4889L10.7953 11.4889L11.5953 11.4889Z"
                            fill="#D11044" />
                    </svg>
                </button>
            </div>
        </ng-template>
    </ng-select>
    <hr>
</div>